import type { ButtonHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

const variants: Record<ButtonVariant, string> = {
  primary:
    "border-gold/40 bg-gradient-to-br from-gold/90 to-ember/90 text-ink shadow-[0_12px_28px_rgba(177,99,51,0.28)] hover:from-gold hover:to-ember",
  secondary:
    "border-gold/25 bg-parchment/10 text-parchment hover:bg-parchment/16 hover:border-gold/45",
  ghost:
    "border-transparent bg-transparent text-mist hover:bg-parchment/8 hover:text-parchment",
  danger:
    "border-red-400/30 bg-red-900/30 text-red-100 hover:bg-red-900/45 hover:border-red-300/50"
};

export function buttonStyles(
  variant: ButtonVariant = "primary",
  className?: string,
) {
  return cn(
    "inline-flex items-center justify-center rounded-xl border px-4 py-2.5 text-sm font-semibold tracking-wide transition duration-200 disabled:cursor-not-allowed disabled:opacity-60",
    variants[variant],
    className,
  );
}

export function Button({
  className,
  variant = "primary",
  type = "button",
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={buttonStyles(variant, className)}
      {...props}
    />
  );
}
